import cn from "classnames";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronDoubleLeft as ChevronDoubleLeftIcon,
} from "@rshbintech.dboul/icons";
import { PaginationButtonType } from "./types";
import styles from "./styles.module.scss";

export const PAGINATION_BUTTON_ICON: Record<
  Exclude<PaginationButtonType, "default">,
  JSX.Element
> = {
  "arrow-left": (
    <ChevronLeftIcon size="small" className={styles["chevron-icon"]} />
  ),
  "arrow-right": (
    <ChevronLeftIcon
      size="small"
      className={cn(styles["chevron-icon"], styles.rotated)}
    />
  ),
  "double-arrow-left": (
    <ChevronDoubleLeftIcon size="small" className={styles["chevron-icon"]} />
  ),
  "double-arrow-right": (
    <ChevronDoubleLeftIcon
      size="small"
      className={cn(styles["chevron-icon"], styles.rotated)}
    />
  ),
};
